import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import config from '../../../AppConfig';
import { fetchData } from '../../../redux/apiSlice';
import FundingSnapshotLogo from "../../../assets/images/FundingImage.png";

function Header(props) {

    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [cobrandLogo, setCobrandLogo] = useState(null);
    const [creditSnapshotObj, setCreditSnapshotObj] = useState(null);
    const [mobile,setMobile]=useState();
    const [logoName, setLogoName] = useState();
    const getAidDetails = async () => {
        // const apiUrl = "/getCobrandAid/details/"+props.aid;
        const apiUrl = "/getCobrandAid/details/" + props.aid + '/' + props.logoName;
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            if (res.success == true) {
                setLogoName(res.logoName);
                setCobrandLogo(res.creditSnapshot.funding_shot.funding_shot_logo_url);
                props.onValueChange(res.creditSnapshot);
                setCreditSnapshotObj(res.creditSnapshot);
                const phoneList = JSON.parse(res.creditSnapshot.snapshot_phone_no || '[]');
                if (phoneList.length > 0) {
                setMobile(phoneList[0].number);
                }
                if (localStorage.getItem("credentialsStatus") != null) {
                    localStorage.removeItem("credentialsStatus");
                }
                localStorage.setItem("credentialsStatus", res.credentialsStatus)
                localStorage.setItem("cobrandCompanyName", res.cobrand_company_name)
            } else {
                if (localStorage.getItem("credentialsStatus") != null) {
                    localStorage.removeItem("credentialsStatus");
                }
            }
        }
    }

    useEffect(() => {
        // alert(props.customColorArray.primaryColor)
        getAidDetails();
    }, [props.aid]);

    return (
        <>
            <Box sx={{ boxShadow: '0 4px 20px -4px rgba(0,0,0,0.2)', mb: 1 }}>
                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Grid item lg={7} md={7} sm={5} xs={5} sx={{ p: 1, textAlign: "left",display:"flex",alignItems:isMobile?"center":"left" }}>
                        {/* <Link to='/'> */}
                        <img alt="#" src={FundingSnapshotLogo} style={{ height: isMobile ? "45px" : "65px" }} />
                        {/* </Link> */}
                    </Grid>
                    <Grid item lg={5} md={5} sm={7} xs={7} p={1} >
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <Grid item lg={7} md={7} sm={12} xs={12} mb={isMobile?1:0} sx={{display: "flex",justifyContent: "center",alignItems: "center",textAlign:"end",borderRight: isMobile?'none':'1px solid black' }} >
                                <Typography sx={{ color: "#6D6666", fontSize: isMobile ? "9px" : "12px" }} pr={2}>
                                    Brought To You By
                                </Typography>
                                <img
                                    alt="Logo"
                                    src={config.BACKEND_URL + '/images/fundingShotLogo/' + cobrandLogo}
                                    style={{ verticalAlign: 'middle', height: isMobile ? "40px" : "65px" }}
                                />                                
                            </Grid>
                            <Grid item lg={5} md={5} sm={12} xs={12}>
                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{justifyContent:isMobile?"end":"center",}}>
                                    {isMobile?
                                    <>
                                    <Divider orientation="vertical"  style={{ background: "black", borderWidth: "1px",width:"100%" }} />
                                    </>
                                    :
                                    <>
                                    {/* <Divider orientation="vertical" flexItem style={{ background: "black", height:"60px" }} />&nbsp;&nbsp;&nbsp; */}
                                    </>
                                    }
                                    <Typography variant="body1" sx={{ display: "flex", fontSize:isMobile? '12px':'16px' , alignItems:isMobile? "right":"center",pr:isMobile?1:0,color:"#064690" }}><b>Call Us Now: {mobile}</b></Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Box>
        </>
    );
}
export default Header;